import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import frameImage from './assets/Frame(1).png';

export default function TermsModal({ onAccept, onClose }) {
  const [isChecked, setIsChecked] = useState(false)
  const [isOpen, setIsOpen] = useState(true); // Track modal open state
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center">
      {isOpen && (
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-50 z-40" // Overlay styles
          onClick={onClose} // Close modal on overlay click
        />
      )}
      <div 
        className="bg-white rounded-xl z-50" // Ensure modal is above overlay
        style={{
          width: '550px', // Fixed width
          height: '265px', // Allow height to adjust based on content
          top: '150px', // Positioning
          left: '400px', // Positioning
          gap: '0px', // Gap
          borderRadius: '12px', // Border radius
          boxShadow: '0px 25px 50px -12px #00000040, 0px 0px 0px 1px #1118271A', // Box shadow
          position: 'absolute', // Ensure positioning works
        }}
      >
        <div 
          style={{
            width: '100%', // Fill width
            height: '48px', // Fixed height
            padding: '8px 16px', // Padding
            display: 'flex', // Flexbox for layout
            justifyContent: 'space-between', // Space between title and close button
            borderBottom: '1px solid #D1D5DB', // Gray line below header
          }}
        >
          <div 
            style={{
              display: 'flex', // Flexbox for layout
              alignItems: 'center', // Center vertically
              gap: '4px', // Gap between image and text
              width: 'auto', // Allow width to adjust based on content
              height: '24px', // Fixed height
            }}
          >
            <img 
              src={frameImage} 
              alt="Frame Icon" 
              style={{ width: '18px', height: '18px' }} // Image size
            />
            <div 
              style={{
                fontFamily: 'Inter, sans-serif', // Font family
                fontSize: '16px', // Font size
                fontWeight: 500, // Font weight
                lineHeight: '24px', // Line height
                letterSpacing: '-0.3px', // Letter spacing
                textAlign: 'left', // Text alignment
                textUnderlinePosition: 'from-font', // Text underline position
                textDecorationSkipInk: 'none', // Text decoration skip
              }}
            >
              Terms & conditions
            </div>
          </div>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div 
          className="flex flex-col items-start justify-center px-6 pb-6"
          style={{
            width: '100%', // Fill width
            height: '138px', // Fixed height for content
            padding: '16px ', // Padding
            gap: '4px', // Gap between elements
          }}
        >
          <div 
            style={{
              width: '360px', // Fixed width
              height: '30px', // Fixed height
              gap: '0px', // Gap
              fontFamily: 'Inter, sans-serif', // Font family
              fontSize: '20px', // Font size
              fontWeight: 500, // Font weight
              lineHeight: '30px', // Line height
              letterSpacing: '-0.5px', // Letter spacing
              textAlign: 'left', // Text alignment
              textUnderlinePosition: 'from-font', // Text underline position
              textDecorationSkipInk: 'none', // Text decoration skip
            }}
          >
            By clicking {'\''}
            <span className="text-blue-500">Start interview</span>
            {'\''}, you accept:
          </div>
          <div 
            className="text-xl text-gray-600" 
            style={{
              fontFamily: 'Inter, sans-serif', // Font family
              fontSize: '16px', // Font size
              fontWeight: 400, // Font weight
              lineHeight: '24px', // Line height
              letterSpacing: '-0.3px', // Letter spacing
              textAlign: 'left', // Text alignment
              textUnderlinePosition: 'from-font', // Text underline position
              textDecorationSkipInk: 'none', // Text decoration skip
              marginTop: '4px', // Added margin to create gap
            }}
          >
            That your audio & video will / can be recorded, only for verification purposes and to verify
            the authenticity of the candidate appearing for the interview. Please read our{" "}
            <button 
              onClick={() => navigate('/terms-and-conditions')}
              className="text-blue-500 underline hover:text-blue-700 cursor-pointer"
            >
              Terms and Conditions
            </button>{" "}
            before proceeding.
          </div>
        </div>

        <div className="flex items-center space-x-2 px-6 pb-2">
          <input 
            type="checkbox" 
            id="terms" 
            style={{ marginTop: '-10px' }}
            className="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <label
            htmlFor="terms"
            style={{
              fontFamily: 'Inter, sans-serif', // Font family
              fontSize: '16px', // Font size
              fontWeight: 400, // Font weight
              lineHeight: '24px', // Line height
              letterSpacing: '-0.3px', // Letter spacing
              textAlign: 'left', // Text alignment
              textUnderlinePosition: 'from-font', // Text underline position
              textDecorationSkipInk: 'none',
              marginTop: '-10px', // Text decoration skip
            }}
            className="text-sm font-medium text-gray-700"
          >
            I agree to the terms and conditions
          </label>
        </div>

        <div 
          className="flex justify-center items-center" 
          style={{
            width: '500px', // Fill width
            height: '40px', // Fixed height
            padding: '2px 10px', // Padding
            gap: '8px', // Gap between elements
            borderRadius: '8px', // Border radius
            border: '1px solid transparent', // Border
            background: isChecked 
              ? 'linear-gradient(0deg, var(--Black, #000000), var(--Black, #000000)), linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%)' 
              : 'gray', // Set background to gray when checkbox is not checked
            boxShadow: '0px 6px 13px 0px #00000026, 0px 23px 23px 0px #00000021, 0px 53px 32px 0px #00000014, 0px 94px 38px 0px #00000005, 0px 147px 41px 0px #00000000', // Box shadows
            marginTop: '-1px',
            marginLeft: '20px', // Move button downward to create space
          }}
        >
          <button
            className={`w-full text-white`}
            disabled={!isChecked}
            onClick={() => {
              if (isChecked) {
                onAccept(); // Call the accept function passed as prop
              }
            }}
          >
            Accept and start interview
            <span className="ml-2">→</span>
          </button>
        </div>
      </div>
    </div>
  )
}

